import {
  Container,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import { useConfirmationDialog } from 'components/Dialog/ConfirmDialog'
import { find, map } from 'lodash'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getTipoUsuarioLogado } from 'store/modules/auth/auth.selectors'
import { callExcluirOcupacaoArea, callSelecionarOcupacaoArea } from 'store/modules/ocupacaoArea'
import { getOcupacaoArea } from 'store/modules/ocupacaoArea/ocupacaoArea.selectors'
import { TIPO_USUARIO } from 'utils/constantes'
import { formatDecimal } from 'utils/numbers'

const useStyles = makeStyles((theme) => ({
  main: {
    color: '#dc3545',
    padding: 0,
    '& .MuiSvgIcon-root': {
      fill: theme.palette.grey.blue,
      '&:hover': {
        fill: theme.palette.blue.main,
      },
    },
  },
  title: {
    fontFamily: theme.typography.secondary,
    fontWeight: 400,
    fontSize: 12,
    color: theme.palette.grey.blue,
  },
  description: {
    fontFamily: theme.typography.secondary,
    fontWeight: 400,
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}))

const OcupacaoAreaLista = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const classes = useStyles()
  const dialog = useConfirmationDialog()
  const ref = useRef()

  const ocupacaoAreas = useSelector(getOcupacaoArea)
  const tipoUsuarioLogado = useSelector(getTipoUsuarioLogado)

  const handleEdit = (id) => {
    window.scrollTo(0, ref.current.offsetTop - 80)
    dispatch(callSelecionarOcupacaoArea({ id }))
  }

  const handleDelete = async (id) => {
    if (tipoUsuarioLogado !== TIPO_USUARIO.CLIENTE.LEITOR) {
      const deletar = find(ocupacaoAreas, { id })
      const result = await dialog.showConfirmation({
        title: t('dialogs.confirmarExclusao'),
        message: t('dialogs.excluirOcorrencia', { ocorrencia: deletar.descricao }),
      })
      if (result) {
        dispatch(callExcluirOcupacaoArea({ id }))
      }
    }
  }

  return (
    <Container className={classes.main} ref={ref}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.title}>{t('pressaoBiodiversidade.ocorrencia')}</TableCell>
              <TableCell className={classes.title}>{t('pressaoBiodiversidade.hectares')}</TableCell>
              <TableCell className={classes.title}>{t('pressaoBiodiversidade.acoes')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {map(ocupacaoAreas, ({ id, descricao, quantidadeCalculada }) => (
              <TableRow key={id}>
                <TableCell className={classes.description}>{descricao}</TableCell>
                <TableCell className={classes.description}>
                  {formatDecimal({
                    value: quantidadeCalculada,
                    min: 2,
                    max: 20,
                    locale: i18n.language,
                  })}
                </TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => handleEdit(id)}>
                    <EditOutlinedIcon fontSize="medium" />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(id)}>
                    <DeleteOutlinedIcon fontSize="medium" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  )
}

export default OcupacaoAreaLista
